module.exports = __webpack_public_path__ + "img/bananapancakes.89e91a25.jpg";